export const GA4_EVENT_TYPES = {
    FEATURE_ACTIVATE: "feature_activate",
    FEATURE_COMPLETE: "feature_complete",
    FEATURE_CLICK: "feature_click",
    FEATURE_VIEW: "feature_view",
    FEATURE_SETTINGS: "feature_settings"
} as const;

export const GA4_FEATURE_CATEGORIES = {
    PREFLIGHT: "Pre-flight",
    NAVIGATION: "navigation",
    CAMPAIGN: "Campaign",
    DELIVERABLES: "Deliverables",
    CLIENT: "Client",
    MASTER_TEMPLATES: "Master Templates",
    CREATIVE_LIBRARY_DOWNLOAD: "Creative Library - Download",
    SHARE: "Share"
} as const;

export const GA4_FEATURE_CONTEXTS = {
    PREFLIGHT_REPORT: "Pre-flight report",
    HEADER: "header",
    SIDEBAR: "sidebar",
    EDIT_CLIENT: "Edit Client",
    DELETE_CLIENT: "Delete Client",
    ADD_CLIENT: "Add Client",
    REVIEW_DELIVERABLES: "Quality assurance",
    CLOSE_REVIEW_DELIVERABLES: "Close Review deliverables",
    ADD_CAMPAIGN: "Add Campaign",
    MASTER_TEMPLATES: "Master Templates",
    CREATIVE_LIBRARY_DOWNLOAD: "Creative Library - Download",
    CANCEL_DOWNLOAD: "Cancel download",
    DOWNLOAD_SUCCESSFUL: "Download Successful",
    SHARE_PREVIEW_LINKS: "Share Preview Links",
    CANCEL_SHARE_PREVIEW_LINKS: "Cancel Share Preview Links",
    SEND_PREVIEW_LINKS: "Send Preview Links",
    ADD_TEMPLATE: "Add Template",
    UPDATE_TEMPLATE: "Update Template"
} as const;
